import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/villageActivities',
        name: 'villageActivities',
        meta: { sideMenuLabel: "Attività" },
        component: () => import("./views/villageActivities.vue")
    },
];

export default routes;